import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const setPushSubscriptionState = createAction(`${reduxKey}/SET_PUSH_SUBSCRIPTION_STATE`, (newState)=>({
        newState
    }));
export const togglePushSubscription = createAction(`${reduxKey}/TOGGLE_PUSH_SUBSCRIPTION`, ()=>({}));
export const registerPushSubscription = createAction(`${reduxKey}/REGISTER_PUSH_SUBSCRIPTION`, ()=>({}));
export const unregisterPushSubscription = createAction(`${reduxKey}/UNREGISTER_PUSH_SUBSCRIPTION`, ()=>({}));
export const initPushSubscriptions = createAction(`${reduxKey}/INIT_PUSH_SUBSCRIPTIONS`, ()=>({}));
export const initPushSubscriptionsSuccess = createAction(`${reduxKey}/INIT_PUSH_SUBSCRIPTIONS_SUCCESS`, (subscriptions)=>subscriptions);
export const updatePushSubscriptions = createAction(`${reduxKey}/UPDATE_PUSH_SUBSCRIPTIONS`, (subscriptions)=>subscriptions);

//# sourceMappingURL=actions.js.map